import { getEnvConfig } from '@praxis/component-runtime-env'
import { merge } from 'lodash'

//Add common configs here that may be common for all environments and something not required in TAP configs
const commonConfig = {}

const getAppConfig = async () => {
  const envConfig = await getEnvConfig(
    process.env.REACT_APP_ENV === 'dev' ? '/config.json' : '/app-config',
  )

  return merge(commonConfig, envConfig)
}

export default getAppConfig
